export enum VehicleModelCategoriesEnum {
  RIDE = "RIDE",
  PICKUP = "PICKUP",
  VAN = "VAN",
  VAN_HIGHT_CEILING_EXTRA_LONG = "VAN_HIGHT_CEILING_EXTRA_LONG",
  TRUCK = "TRUCK",
  SEMI_HEAVY_TRUCK = "SEMI_HEAVY_TRUCK",
  HEAVY_TRUCK = "HEAVY_TRUCK",
  CART = "CART"
}
